import type { Speicherstand } from '../unterlagenSpeicher';

export const SPERRE_UNTERLAGEN_SPEICHERT =
    'Die Unterlagen-Checkliste wird noch gespeichert. Gedruckt wird der gespeicherte Stand — bitte einen Moment warten.';
export const SPERRE_UNTERLAGEN_FEHLER =
    'Die Unterlagen-Checkliste konnte nicht gespeichert werden. Gedruckt wird der gespeicherte Stand — '
    + 'speichern Sie die Checkliste erneut (Reiter „Unterlagen").';

/**
 * Warum der Knopf „Dokumentation (PDF)" gerade nicht druckt — oder `null`.
 *
 * Gedruckt wird nur der GESPEICHERTE Stand, wie bei der Klaerungsliste
 * (`exportStand.ts`): mit ungespeicherten Grundlagen stuende eine geaenderte
 * Baubeschreibung neben einer Pruefung, die zu ihr nicht passt. Ein Lesefehler
 * darf nie ein Dokument erzeugen, das wie ein vollstaendiger Stand aussieht.
 *
 * Ausnahme abgeschlossene Phase: dort nimmt die Phase keine Grundlagen mehr
 * an, ein ungespeicherter Entwurf ist also nicht mehr speicherbar. „Erst
 * speichern" sperrte dann fuer immer — gedruckt wird der gespeicherte Stand,
 * und der kommt ohnehin aus dem geladenen Kopfsatz, nie aus dem Entwurf.
 *
 * Die Unterlagen-Checkliste speichert unabhaengig von den Grundlagen
 * (entprellt, `useUnterlagenStand`). Ihre angezeigte Liste ist erst dann der
 * gespeicherte Stand, wenn der Schreiber „gespeichert" meldet — vorher (und
 * nach einem Fehler) truege das PDF eine Checkliste, die nicht in der Akte
 * steht.
 */
export const dokumentationSperre = (lage: {
    laden: boolean;
    fehler: string | null;
    hatPhase: boolean;
    schmutzig: boolean;
    abgeschlossen: boolean;
    /** Speicherstand der Unterlagen-Checkliste (`useUnterlagenStand().stand`). */
    unterlagenStand: Speicherstand;
}): string | null => {
    if (lage.laden) return 'Die Planungsphase wird geladen.';
    if (lage.fehler) return 'Die Planungsphase konnte nicht geladen werden. Ohne vollständigen Stand wird keine Dokumentation erzeugt.';
    if (!lage.hatPhase) return 'Es ist noch keine Planungsphase gespeichert.';
    if (lage.schmutzig && !lage.abgeschlossen) return 'Die Grundlagen sind noch nicht gespeichert. Gedruckt wird der gespeicherte Stand.';
    if (lage.unterlagenStand === 'fehler') return SPERRE_UNTERLAGEN_FEHLER;
    if (lage.unterlagenStand !== 'gespeichert') return SPERRE_UNTERLAGEN_SPEICHERT;
    return null;
};
